import request from '@/util/request'

export function selectArticle (data) {
  return request({
    url: '/article/selectArticle',
    method: 'POST',
    data
  })
}
export function selectJob (data) {
  return request({
    url: '/job/selectJob',
    method: 'POST',
    data
  })
}

export function getconfig (data) {
  return request({
    url: '/common/getconfig',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/website.js